/**
 * require-if-visible
 * Require fields only if they are visible
 *
 * @package:  Monapix
 * @version:  3.0.1
 * @author:   Cyrill N KALITA
 */


$(function(){

    "use strict";

    // Collapsed group of elements
    var $groups = $('.collapse.require-if-visible');

    $groups.each(function(index, group){
        var $group = $(group);
        // Collect all required elements within a group
        var $elements = $group.find(':input[data-required], :radio[data-required]');

        // If the Group is initially visible
        if ($group.is(':visible')){
            $elements.attr('required', 'required');
        } else {
            $elements.removeAttr('required');
        }

        // This event is fired immediately when the hide method has been called.
        $group.on('hide.bs.collapse ', function () {
            $elements.removeAttr('required');
        });

        // This event fires immediately when the show instance method is called.
        $group.on('show.bs.collapse ', function () {
            $elements.attr('required', 'required');
        })
    });

});



// WEBPACK FOOTER //
// ./resources/js/services/jquery/jquery.require-if-visible.js